import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { accountApi } from '../../services/api';
import type { AccountOrderItem } from '../../services/api';
import { AppleEmoji } from '../../components/AppleEmoji';

export default function OrdersView() {
  const [items, setItems] = useState<AccountOrderItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    accountApi
      .orders(page, pageSize)
      .then(({ data }) => {
        setItems(data.items);
        setTotal(data.total);
      })
      .finally(() => setLoading(false));
  }, [page]);

  const pages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="page-view">
      <div className="page-view__header">
        <h1 className="page-view__title">
          <AppleEmoji emoji="📦" size={32} /> История покупок
        </h1>
        <p className="page-view__subtitle">
          Всего заказов: <b>{total}</b>
        </p>
      </div>

      {loading && <div className="orders-empty">Загрузка...</div>}

      {!loading && items.length === 0 && (
        <div className="orders-empty">
          <AppleEmoji emoji="📋" size={40} />
          <div className="orders-empty__title">Пока нет покупок</div>
          <div className="orders-empty__text">Ваши заказы появятся здесь.</div>
        </div>
      )}

      {items.map((o) => (
        <Link
          key={o.uuid}
          to={`/payment/${o.uuid}`}
          className="order-card order-card--link"
        >
          <div className="order-card__left">
            <div className="order-card__emoji">
              <AppleEmoji emoji="💎" size={28} />
            </div>
            <div>
              <div className="order-card__amount">
                {o.direction === 'sell' ? 'Продажа ' : ''}{o.usdt_amount} {(o.asset || 'usdt').toUpperCase()}
              </div>
              <div className="order-card__meta">
                {o.direction === 'sell'
                  ? 'Выплата на карту'
                  : <>{o.wallet_network} · {o.wallet_address.slice(0, 8)}…{o.wallet_address.slice(-4)}</>}
              </div>
            </div>
          </div>
          <div className="order-card__right">
            <div className="order-card__rub">{o.amount_rub.toFixed(0)} ₽</div>
            <div className={`order-card__status order-card__status--${o.status}`}>
              {statusLabel(o.status)}
            </div>
            <div className="order-card__date">
              {new Date(o.created_at).toLocaleDateString('ru-RU')}
            </div>
          </div>
          <span className="order-card__chevron" aria-hidden="true">›</span>
        </Link>
      ))}

      {pages > 1 && (
        <div className="pagination">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
            ←
          </button>
          <span>
            {page} / {pages}
          </span>
          <button disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>
            →
          </button>
        </div>
      )}
    </div>
  );
}

function statusLabel(status: string): string {
  const map: Record<string, string> = {
    pending: 'Ожидает',
    waiting_payment: 'Ждёт оплаты',
    paid: 'Оплачен',
    processing: 'В обработке',
    completed: 'Завершён',
    failed: 'Ошибка',
    cancelled: 'Отменён',
    expired: 'Истёк',
  };
  return map[status] || status;
}
